<template>
  <div>
    <a-table
      filterMultiple
      rowKey="id"
      :columns="columns"
      :data-source="dataList"
      :pagination="false"
    >
      <span slot="action" slot-scope="text, record">
        <a-space>
          <a-button size="small" type="link" @click="deleteHandle(record)"
            >删除</a-button
          >
        </a-space>
      </span>
    </a-table>
    <div style="margin-top: 20px; float: right">
      <a-button
        @click="goTrain()"
        style="background: #0073ff; border: none; color: #ffffff"
      >
        完成录入，去培训
      </a-button>
    </div>
    <a-pagination
      style="margin-top: 20px; float: left"
      show-size-changer
      :current="page"
      show-quick-jumper
      :total="controlRot.length"
      @showSizeChange="showSizeChange"
      @change="pageCurrentChangeHandle"
      :show-total="(total) => `共 ${total} 条`"
    />
  </div>
</template>

<script>
export default {
  props: {
    //已经读取或签到得遥控器数据
    controlRot: {
      type: Array,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      columns: [
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 200,
        },
        {
          title: "身份证号",
          dataIndex: "id_no",
          key: "id_no",
          align: "center",
        },
        {
          title: "分配答题器号码",
          dataIndex: "iKeyID",
          key: "iKeyID",
          align: "center",
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      dataList: [],
    };
  },
  mounted() {
    this.getDataByPage();
  },
  methods: {
    getDataByPage() {
      const startIndex = (this.page - 1) * this.pageSize;
      const endIndex = this.page * this.pageSize;
      this.dataList = this.controlRot.slice(startIndex, endIndex);
      if (this.dataList.length == 0 && this.page != 1) {
        this.page -= 1;
        this.getDataByPage();
      }
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val;
      this.getDataByPage();
    },
    showSizeChange(current, pageSize) {
      this.page = current;
      this.pageSize = pageSize;
      this.getDataByPage();
    },
    goTrain() {
      this.$emit("goTrain");
    },
    //删除一个
    deleteHandle(record) {
      this.$emit("deleteControlRot", record);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>